// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { MappedTestRequest } from './mapped-test-request';

/** See com.rev360.pms.api.controller.patient.encounter.workflow.device.PreviewMappedTestsRequest */
/* istanbul ignore next */
@GandalfModel
export class PreviewMappedTestsRequest extends GandalfModelBase {

	@GandalfArray(MappedTestRequest)
	mappedTests!: MappedTestRequest[];

}
